// extracted by mini-css-extract-plugin
export default {"table-container":"table_table-container__UqBwd"};